import { StreamEl } from '@mi-front/ui';
import { Box } from '@mui/material';
import { TsThumbnail } from '../../../../../../../core/thumbnails/components/TsThumbnail';
import { THUMBNAIL_HEIGHT } from '../../../../../../../core/thumbnails/consts';

interface Props {
  stationId: string;
  ts: number;
}

/**
 * Hover thumbnail over the stream waveform. Light elevation separates it from the graph;
 * status-card thumbs stay flat with only the divider border.
 */
export function StreamThumbnail({ stationId, ts }: Props) {
  return (
    <StreamEl
      ts={ts}
      checkOverflow
      offsetX={10}
      offsetY={THUMBNAIL_HEIGHT / 2 + 20}
      zIndex={100}
      position="center"
      noEvents
    >
      <Box sx={{ boxShadow: 1, borderRadius: 1, lineHeight: 0 }}>
        <TsThumbnail
          stationId={stationId}
          ts={ts}
          useThumbnailOptions={{
            fetchRangeMinutes: 30,
          }}
        />
      </Box>
    </StreamEl>
  );
}
